import React from 'react';
import { Card, CardContent, Stack, Typography } from 'components/base';
import { PersonOutlinedIcon } from 'assets/icons';
import { Button } from 'components/atoms';
import { useAppNavigation } from 'hooks/useAppNavigation';
import { iconDiv } from '../../styles';
import { useQRStore } from '../../store/useQRStore';

export const GuestUserDetail: React.FC = () => {
  const { userDetail, dataFromURL, mobileNumber } = useQRStore();
  const { navigateTo } = useAppNavigation();

  const handleContinueToForm = () => {
    navigateTo(
      `/forms-qr/add-response/${dataFromURL?.formID}?from_QR=${dataFromURL?.fromQR}?link_id=${dataFromURL?.linkID}?has_prefill=${dataFromURL?.hasPrefill}`,
    );
  };

  return (
    <Card raised sx={{ maxWidth: '80%' }}>
      <CardContent>
        <Stack p={2} spacing={2}>
          <Stack sx={iconDiv} bgcolor="primary.background">
            <PersonOutlinedIcon fontSize="large" color="primary" />
          </Stack>
          <Typography variant="h5" color="text.primary" alignSelf="center">
            Welcome, {userDetail?.first_name} !
          </Typography>
          <Typography variant="body2" color="text.secondary" alignSelf="center">
            Your identity has been verified. Below mentioned details will be
            used for this submission
          </Typography>
          <Stack
            p={2}
            spacing={1}
            bgcolor="primary.background"
            borderRadius={2}
          >
            <Typography variant="subtitle2" color="normalText.light">
              Mobile: {userDetail?.phone_number ?? mobileNumber}
            </Typography>
            <Typography variant="subtitle2" color="normalText.light">
              Email: {userDetail?.email}
            </Typography>
            <Typography variant="subtitle2" color="normalText.light">
              Company: {userDetail?.company_name ?? '-'}
            </Typography>
          </Stack>

          <Button onClick={handleContinueToForm}>Continue to Form</Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
